import axios from "axios"

export default {
    namespaced: true,

    state: {
        surveys: []
    },
    mutations: {
        setSurvey(state, array){
            state.surveys = array
        }
    },
    actions: {
        fetchData(context, payload){
            let lang = payload.lang
            axios({
                method: "POST",
                data: {
                    query: `{
                              survey: entries(section: "surveys", orderBy: "title ASC", site:"` + lang +`"){
                                id,
                                title,
                                slug,
                                surveytype,
                                surveyContent {
                                  ... on surveyContent_surveyQuestion_BlockType {
                                    id,
                                    selectedQuestion {
                                      ... on surveyQuestions_surveyQuestions_Entry {
                                        id,
                                        title,
                                        questionContent {
                                          ... on questionContent_mainQuestion_BlockType {
                                            id,
                                            __typename,
                                            questionTitle
                                          },
                                          ... on questionContent_answerRadio_BlockType {
                                            id,
                                            __typename,
                                            answer,
                                            subQuestion {
                                              id,
                                              ... on surveyQuestions_surveyQuestions_Entry {
                                                id,
                                                title,
                                                ...questions
                                              }
                                            }
                                          },
                                          ... on questionContent_answerCheckbox_BlockType {
                                            id,
                                            __typename,
                                            answer,
                                            subQuestion {
                                              id,
                                              ... on surveyQuestions_surveyQuestions_Entry {
                                                id,
                                                title,
                                                ...questions
                                              }
                                            }
                                          },
                                          ... on questionContent_answerTextfield_BlockType {
                                            id,
                                            __typename,
                                            subQuestion {
                                              id,
                                              ... on surveyQuestions_surveyQuestions_Entry {
                                                id,
                                                title,
                                                ...questions
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            fragment questions on surveyQuestions_surveyQuestions_Entry {
                              id,
                              questionContent {
                                ... on questionContent_mainQuestion_BlockType {
                                  id,
                                  __typename,
                                  questionTitle
                                },
                                ... on questionContent_answerRadio_BlockType {
                                  id,
                                  __typename,
                                  answer
                                },
                                ... on questionContent_answerCheckbox_BlockType {
                                  id,
                                  __typename,
                                  answer
                                },
                                ... on questionContent_answerTextfield_BlockType {
                                  id,
                                  __typename
                                }
                              }
                            }`
                }
            }).then(function(res){
                context.commit('setSurvey', res.data.data.survey)
            })
        }
    },
    getters: {}
}
